/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Timemustbeinformathhmmss7Inputs */

const en_timemustbeinformathhmmss7 = /** @type {(inputs: Timemustbeinformathhmmss7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Time must be in HH:mm:ss format`)
};

const de_timemustbeinformathhmmss7 = /** @type {(inputs: Timemustbeinformathhmmss7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zeit muss im Format HH:mm:ss sein`)
};

/**
* | output |
* | --- |
* | "Time must be in HH:mm:ss format" |
*
* @param {Timemustbeinformathhmmss7Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const timemustbeinformathhmmss7 = /** @type {((inputs?: Timemustbeinformathhmmss7Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timemustbeinformathhmmss7Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_timemustbeinformathhmmss7(inputs)
	return de_timemustbeinformathhmmss7(inputs)
});
export { timemustbeinformathhmmss7 as "timeMustBeInFormatHhMmSs" }